import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { PipesModule } from "../../../pipes/pipes.module";
import { ImageUploadModule } from "../../../components/archivos/image-upload.module";
import { EliminarImagenNoticiaComponent } from "./eliminar-imagen-noticia/eliminar-imagen-noticia.component";
import { EliminarImagenNoticiaDialog } from "./eliminar-imagen-noticia/eliminar-imagen-noticia-dialog/eliminar-imagen-noticia-dialog.component";
import { SubirArchivosNoticiaComponent } from "./subir-archivos-noticia/subir-archivos-noticia.component";
import { VerArchivosNoticiaComponent } from "./ver-archivos-noticia/ver-archivos-noticia.component";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        PipesModule,
        ImageUploadModule.forRoot()
    ],
    declarations: [
        EliminarImagenNoticiaComponent,
        EliminarImagenNoticiaDialog,
        SubirArchivosNoticiaComponent,
        VerArchivosNoticiaComponent,
    ],
    entryComponents: [
        EliminarImagenNoticiaDialog,
    ],
    exports: [
        EliminarImagenNoticiaComponent,
        SubirArchivosNoticiaComponent,
        VerArchivosNoticiaComponent,
    ]
})
export class ArchivoNoticiaModule { }